import type { SVGProps } from "react";
export interface MessageFaceIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MessageFaceIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MessageFaceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 6c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h2c.62 0 1.125.504 1.125 1.125v1.77l3.534-2.25a4.13 4.13 0 0 1 2.215-.645H19c1.035 0 1.874-.84 1.875-1.875zm2.25 10A4.125 4.125 0 0 1 19 20.125h-5.126c-.268 0-.531.056-.773.166l-.233.128L9.14 22.79c-1.414.9-3.266-.115-3.266-1.791v-.873H5A4.125 4.125 0 0 1 .875 16V6A4.125 4.125 0 0 1 5 1.875h14A4.125 4.125 0 0 1 23.125 6z"
      />
      <path
        fill={color}
        d="M15.175 12.737a1.125 1.125 0 0 1 1.724 1.44l-.217.27a6.11 6.11 0 0 1-4.681 2.178 6.11 6.11 0 0 1-4.684-2.177l-.216-.271-.065-.097a1.126 1.126 0 0 1 1.79-1.343l.073.088.138.173A3.87 3.87 0 0 0 12 14.375a3.87 3.87 0 0 0 3.1-1.55zM15 7.627a.62.62 0 0 0-.126.373l.014.126a.6.6 0 0 0 .113.246zm1 .745a.6.6 0 0 0 .112-.246L16.126 8l-.014-.126A.6.6 0 0 0 16 7.627zm-6.888-.498A.6.6 0 0 0 9 7.629v.741a.6.6 0 0 0 .112-.244L9.125 8zM8 7.629a.62.62 0 0 0-.125.37l.012.127A.6.6 0 0 0 8 8.37zm2.126.37a1.625 1.625 0 0 1-3.242.167L6.875 8l.009-.166A1.625 1.625 0 0 1 8.5 6.375l.166.009c.82.083 1.46.775 1.46 1.616Zm6.999 0a1.625 1.625 0 0 1-3.242.168L13.876 8l.007-.166A1.626 1.626 0 0 1 17.125 8Z"
      />
    </svg>
  );
}
